import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, useContext } from '@nuxtjs/composition-api'
import { useMenuModel } from '@entities/menu'
import { AppButton } from '@shared/ui'
import { useOrderModel } from '@entities/order'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddingMenu',
  emits: ['toggleBaseAlert'],
  setup(__props, { emit: emits }) {



const { $cookies } = useContext()

const menuModel = useMenuModel()
const orderModel = useOrderModel()

const addButtonFaster = ref(false)

const onAddFaster = async () => {
  $cookies.set('addButtonFaster', 'true')
  addButtonFaster.value = true
  emits('toggleBaseAlert', true)
  setTimeout(() => {
    emits('toggleBaseAlert', false)
  }, 3000)
  if (orderModel.orderData.settings) {
    await menuModel.addingMenu(orderModel.orderData.settings.shop_id)
  }
}

onMounted(() => {
  addButtonFaster.value = $cookies.get('addButtonFaster')
})


return { __sfc: true,emits, $cookies, menuModel, orderModel, addButtonFaster, onAddFaster, AppButton }
}

})